// extracted by mini-css-extract-plugin
export default {"root":"TX8OR","left":"_2hAu3","right":"_3xM_3"};